import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { cardNumberValidator, emailValidator } from '@iw/core/helpers';

import { WithdrawalMethodId } from './methods';

const createPaypalForm = (fb: FormBuilder): FormGroup => {
  return fb.group({
    email: [<string>null, [Validators.required, emailValidator()]],
  });
};

const createCardForm = (fb: FormBuilder): FormGroup => {
  return fb.group({
    name: [<string>null, [Validators.required, Validators.maxLength(25)]],
    surname: [<string>null, [Validators.required, Validators.maxLength(25)]],
    cardNumber: [<string>null, [Validators.required, cardNumberValidator()]],
    description: [
      <string>null,
      [Validators.required, Validators.maxLength(200)],
    ],
  });
};

const createAdvcashForm = (fb: FormBuilder): FormGroup => {
  return fb.group({
    walletAddress: [<string>null, Validators.required],
  });
};

const createCODEOfficeForm = (fb: FormBuilder): FormGroup => {
  return fb.group({});
};

const createBankTransferInrForm = (fb: FormBuilder): FormGroup => {
  return fb.group({
    name: [<string>null, Validators.required],
    surname: [<string>null, Validators.required],
    accountNumber: [
      <string>null,
      [Validators.required, Validators.minLength(9), Validators.maxLength(18)],
    ],
    bankIfsc: [<string>null, Validators.required],
    bankName: [<string>null, Validators.required],
    description: [
      <string>null,
      [Validators.required, Validators.maxLength(200)],
    ],
  });
};

const createCryptoForm = (fb: FormBuilder): FormGroup => {
  return fb.group({
    address: [<string>null, [Validators.required]],
    description: [<string>null, [Validators.maxLength(200)]],
  });
};

export const buildFormForMethod = (
  method: WithdrawalMethodId,
  fb: FormBuilder,
): FormGroup => {
  if (!method) {
    return null;
  }

  switch (method) {
    case WithdrawalMethodId.Paypal:
      return createPaypalForm(fb);
    case WithdrawalMethodId.CardPersonal:
      return createCardForm(fb);
    case WithdrawalMethodId.ADVCash:
      return createAdvcashForm(fb);
    case WithdrawalMethodId.BankTransferINR:
      return createBankTransferInrForm(fb);
    case WithdrawalMethodId.CODEOffice:
      return createCODEOfficeForm(fb);
    case WithdrawalMethodId.Crypto:
      return createCryptoForm(fb);
    default:
      return null;
  }
};
